var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"py-6",staticStyle:{"background":"#3F3E40"},attrs:{"dark":""}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"text-center"},[_vm._v(" Yohann Hamonic - Photographies ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }